<template>
  <v-container fluid>
    <v-card class="elevation-1 mb-6">
      <ValidationObserver ref="calculatorForm" v-slot="{ invalid, passes }">
        <v-form rel="calculatorForm" @submit.prevent="passes(doCalculate)">
          <v-card-title class="pa-7">Kalkulačka elektřina</v-card-title>
          <v-card-text class="pa-7">
            <v-row>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model.trim="postalCode"
                  rules="required"
                  label="PSČ"
                  outlined
                  dense
                  type="number"
                  background-color="white"
                  :loading="distributorLoading"
                  @input="(event) => loadDistributor(event)"
                />
              </v-col>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <v-text-field
                  v-model="distributor.name"
                  label="Distributor"
                  dense
                  readonly
                  disabled
                  background-color="white"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" class="py-0 px-6">
                <v-switch
                  v-model="areaFlat"
                  inset
                  dense
                  :disabled="disabledWh"
                  @change="handleAreaValue"
                >
                  <template slot="label">
                    <div style="color: #21262a">
                      {{ areaFlat ? 'Byt' : 'Dům' }}
                    </div>
                  </template>
                </v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="areaFlat" cols="12" sm="12" class="py-0 px-5">
                <v-radio-group
                  v-model="areaId"
                  mandatory
                  row
                  :disabled="disabledWh"
                  @change="doCalculateState"
                >
                  <v-radio
                    v-for="item in areaFlats"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </v-radio-group>
              </v-col>
              <v-col v-if="!areaFlat" cols="12" sm="12" class="py-0 px-5">
                <v-radio-group
                  v-model="areaId"
                  mandatory
                  row
                  :disabled="disabledWh"
                  @change="doCalculateState"
                >
                  <v-radio
                    v-for="item in areaHouses"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <v-radio-group
                  v-model="usageIds"
                  mandatory
                  multiple
                  row
                  :disabled="disabledWh"
                  @change="doCalculateState"
                >
                  <v-radio
                    v-for="item in usages"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :checked="item.active"
                    @click="uncheckUsage(item)"
                  />
                </v-radio-group>
              </v-col>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <v-radio-group
                  v-model="personId"
                  mandatory
                  row
                  :disabled="disabledWh"
                  @change="doCalculateState"
                >
                  <v-radio
                    v-for="item in persons"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="mt-10">
              <v-col cols="12" sm="6" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model="form.rateId"
                  label="Distribuční sazba"
                  rules="required"
                  outlined
                  dense
                  background-color="white"
                  :items="rates"
                  item-text="name"
                  item-value="id"
                  :disabled="disabledWh"
                  :loading="ratesLoading"
                  @select="(event) => singleTarif(event)"
                  @change="loadCircuitBreakersAndSupplierProducts"
                />
              </v-col>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="form.circuitBreakerId"
                  label="Jistič"
                  rules="required"
                  outlined
                  dense
                  background-color="white"
                  :items="circuitBreakers"
                  item-text="name"
                  item-value="id"
                  :disabled="disabledWh"
                  :loading="circuitBreakersLoading"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="form.supplierId"
                  label="Dodavatel"
                  outlined
                  dense
                  background-color="white"
                  :items="suppliers"
                  item-text="name"
                  item-value="id"
                  :disabled="disabledWh"
                  :loading="suppliersLoading"
                  @change="(event) => loadSupplierProduct(event)"
                />
              </v-col>
              <v-col cols="12" sm="6" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="form.supplierProductId"
                  label="Produkt"
                  outlined
                  dense
                  background-color="white"
                  :items="supplierProducts"
                  item-text="name"
                  item-value="id"
                  :disabled="disabledWh"
                  :loading="suppliersProductLoading"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="9" class="py-0 px-5">
                <v-slider
                  v-model="form.consumptionHT"
                  label="Vysoký tarif"
                  max="65000"
                  min="0"
                  class="pt-6"
                  :disabled="disabledWh"
                ></v-slider>
              </v-col>
              <v-col cols="12" sm="3" class="py-0 px-5 pt-5">
                <VTextFieldWithValidation
                  v-model.trim="form.consumptionHT"
                  outlined
                  dense
                  suffix="kWh/rok"
                  type="number"
                  class="right-input"
                  background-color="white"
                  hide-messages
                  :disabled="disabledWh"
                />
              </v-col>
            </v-row>
            <v-row v-if="!singleTarif">
              <v-col cols="12" sm="9" class="py-0 px-5">
                <v-slider
                  v-model="form.consumptionLT"
                  label="Nízký tarif"
                  max="65000"
                  min="0"
                  class="pt-6"
                  :disabled="disabledWh"
                ></v-slider>
              </v-col>
              <v-col cols="12" sm="3" class="py-0 px-5 pt-5">
                <VTextFieldWithValidation
                  v-model.trim="form.consumptionLT"
                  outlined
                  dense
                  suffix="kWh/rok"
                  type="number"
                  class="right-input"
                  background-color="white"
                  hide-messages
                  :disabled="disabledWh"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-7">
            <v-spacer></v-spacer>
            <v-btn
              :disabled="disabledWh"
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :loading="calcLoading"
            >
              Spočítat
            </v-btn>
          </v-card-actions>
        </v-form>
      </ValidationObserver>
    </v-card>
    <v-row v-if="result" class="mb-6">
      <v-col v-for="(item, index) in result.products" :key="index" cols="12" sm="3" md="4">
        <v-card height="100%">
          <v-card-title class="px-7">
            <v-img height="24" contain position="left" :src="item.supplier.logoUrl"></v-img>
          </v-card-title>
          <v-card-title class="px-7">
            {{ item.supplier.name }}
          </v-card-title>
          <v-card-text class="px-7">
            <table style="width: 100%">
              <tr>
                <th align="left">Produkt:</th>
                <td align="right" v-html="item.product.name" />
              </tr>
              <tr>
                <th align="left">Cena:</th>
                <td align="right">{{ item.annualPrice }} Kč</td>
              </tr>
              <tr>
                <th align="left">Úspora:</th>
                <td align="right">{{ item.annualSaving }} Kč</td>
              </tr>
            </table>
            <br />
            <table style="width: 100%">
              <tr>
                <th align="left">Index</th>
                <td align="right">
                  {{ item.supplier.rating ? item.supplier.rating.index : 'neohodnoceno' }}
                </td>
              </tr>
            </table>
            <div v-if="item.supplier.rating">
              <div
                v-for="(itemRating, indexRating) in item.supplier.rating.values"
                :key="indexRating"
              >
                <table style="width: 100%">
                  <tr>
                    <th align="left">{{ itemRating.name }}</th>
                    <td align="right">{{ itemRating.value }}</td>
                  </tr>
                </table>
              </div>
            </div>
            <br v-if="item.supplier.gifts && item.supplier.gifts.length" />
            <div v-if="item.supplier.gifts && item.supplier.gifts.length">
              <table style="width: 100%">
                <tr v-for="(gift, indexGift) in item.supplier.gifts" :key="indexGift">
                  <th align="left" style="color: #fe4600">
                    {{ gift.name }}
                  </th>
                </tr>
              </table>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import VAutocompleteWithValidation from '@/components/validators/VAutocompleteWithValidation'

export default {
  name: 'ElectricityCalculator',
  components: { VAutocompleteWithValidation },
  data() {
    return {
      form: {
        postalCode: null,
        distributorId: null,
        rateId: null,
        circuitBreakerId: null,
        supplierId: null,
        supplierProductId: null,
        consumptionHT: null,
        consumptionLT: null,
      },
      distributor: {
        name: null,
      },
      areaFlats: [
        {
          id: 1,
          name: 'Do 50m2',
        },
        {
          id: 2,
          name: 'Do 80m2',
        },
        {
          id: 3,
          name: 'Nad 80m2',
        },
      ],
      areaHouses: [
        {
          id: 4,
          name: 'Do 90m2',
        },
        {
          id: 5,
          name: 'Do 150m2',
        },
        {
          id: 6,
          name: 'Nad 150m2',
        },
      ],
      areaId: 1,
      areaFlat: true,
      persons: [
        {
          id: 1,
          name: '1-2 osoby',
        },
        {
          id: 2,
          name: '3-4 osoby',
        },
        {
          id: 3,
          name: '5 a více osob',
        },
      ],
      personId: 1,
      usages: [
        {
          id: 1,
          name: 'Svícení',
        },
        {
          id: 2,
          name: 'Vaření',
        },
        {
          id: 3,
          name: 'Ohřev vody',
        },
        {
          id: 4,
          name: 'Topení',
        },
      ],
      usageIds: [1],
      postalCode: null,
      rates: [],
      circuitBreakers: [],
      suppliers: [],
      supplierProducts: [],
      result: null,
      distributorLoading: false,
      circuitBreakersLoading: false,
      ratesLoading: false,
      suppliersLoading: false,
      suppliersProductLoading: false,
      calcLoading: false,
      calcStateLoading: false,
    }
  },
  computed: {
    disabledWh() {
      return this.form.distributorId == null
    },
    singleTarif() {
      return this.form.rateId == null || this.form.rateId === 1 || this.form.rateId === 2
    },
    isLoading() {
      return this.distributorLoading || this.circuitBreakersLoading || this.ratesLoading
    },
  },
  created() {
    this.loadRates()
    this.loadSuppliers()
  },
  methods: {
    ...mapActions({
      getDistributor: 'electricity/getDistributor',
      getCircuitBreaker: 'electricity/getCircuitBreaker',
      getRates: 'electricity/getRates',
      calculate: 'electricity/calculate',
      calculateState: 'electricity/calculateState',
      getSuppliers: 'electricity/getSuppliers',
      getSupplierProducts: 'electricity/getSupplierProducts',
    }),
    loadDistributor(postalCode) {
      this.form.distributorId = null
      this.distributor = { name: null }
      if (postalCode.toString().length !== 5) {
        return
      }
      this.distributorLoading = true
      this.getDistributor(postalCode)
        .then((response) => {
          this.distributor = response.data
          this.form.postalCode = postalCode
          this.form.distributorId = response.data.id
        })
        .finally(() => {
          this.distributorLoading = false
          this.doCalculateState()
        })
        .catch(() => {})
    },
    loadCircuitBreakers() {
      this.circuitBreakersLoading = true
      this.getCircuitBreaker({
        distributorId: this.form.distributorId,
        rateId: this.form.rateId,
      })
        .then((response) => {
          this.circuitBreakers = response.data
        })
        .finally(() => {
          this.circuitBreakersLoading = false
          if (this.isLoading) {
            this.doCalculateState()
          }
        })
    },
    loadRates() {
      this.ratesLoading = true
      this.getRates()
        .then((response) => {
          this.rates = response.data
        })
        .finally(() => {
          this.ratesLoading = false
          if (this.isLoading) {
            this.doCalculateState()
          }
        })
    },
    loadSuppliers() {
      this.suppliersLoading = true
      this.getSuppliers()
        .then((response) => {
          this.suppliers = response.data
        })
        .finally(() => {
          this.suppliersLoading = false
        })
    },
    loadSupplierProduct() {
      if (this.form.supplierId == null) {
        return
      }
      this.suppliersProductLoading = true
      this.getSupplierProducts({
        id: this.form.supplierId,
        distributorId: this.form.distributorId,
        distributionRateId: this.form.rateId,
      })
        .then((response) => {
          this.supplierProducts = response.data
        })
        .finally(() => {
          this.suppliersProductLoading = false
        })
    },
    doCalculate() {
      if (this.singleTarif) {
        this.consumptionLT = null
      }
      this.calcLoading = true
      this.calculate(this.form)
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.result = response.data
        })
        .finally(() => {
          this.calcLoading = false
        })
    },
    doCalculateState() {
      if (this.calcStateLoading) {
        return
      }
      if (!this.usageIds.length) {
        this.usageIds = [1]
      }
      this.calculateState({
        areaId: this.areaId,
        personId: this.personId,
        usageIds: this.usageIds,
      })
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.form.circuitBreakerId = response.data.circuitBreakerId
          this.form.consumptionHT = response.data.consumptionHT
          this.form.consumptionLT = response.data.consumptionLT
          this.form.rateId = response.data.rateId
          this.loadCircuitBreakersAndSupplierProducts()
        })
        .finally(() => {})
    },
    loadCircuitBreakersAndSupplierProducts() {
      this.loadCircuitBreakers()
      this.loadSupplierProduct()
    },
    handleAreaValue() {
      if (this.areaFlat) {
        this.areaId = this.areaFlats[0].id
      } else {
        this.areaId = this.areaHouses[0].id
      }
      this.doCalculateState()
    },
    uncheckUsage(item) {
      item.active = !item.active
      this.usageIds = this.usageIds.filter((value, index) => this.usageIds.indexOf(value) === index)
      if (!item.active) {
        const removeIndex = this.usageIds
          .map(function (id) {
            return id
          })
          .indexOf(item.id)

        this.usageIds.splice(removeIndex, 1)
        this.doCalculateState()
      }
    },
    removeHtml(value) {
      return value.replace(/<p.*>.*?<\/p>/gi, '')
    },
  },
}
</script>

<style scoped>
.right-input >>> input {
  text-align: right;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
